/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import InvoicingContext from "./InvoicingContext";
import Header from "components/common_components/Header";
import { ConfirmDialog } from "components/common_components/Dialogs";
import Grid from "@material-ui/core/Grid";
import MasterForm from "./Form";
import DetailForm from "./DetailForm";
import DetailTable from "./DetailTable";
import Button from "components/common_components/Button";


function Invoice(props) {
    const { mode } = props;
    const adding = mode === "add";
    const updating = mode === "update";
    const history = useHistory();
    const { id } = useParams();
    const [invoice, setInvoice] = useState(undefined);
    const [selectedDetail, setSelectedDetail] = useState(undefined);
    const [resources, setResources] = useState({
        products: [],
    });
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { Invoices, Products, isUserCreating, setIsUserCreating } = useContext(InvoicingContext);

    const [confirmDialogProps, setConfirmDialogProps] = useState({
        open: false,
        title: "",
        content: "",
        primaryButtonText: "",
        onPrimaryClick: undefined,
        secondaryButtonText: "Cancel",
        onSecondaryClick: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
        onClose: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
    });

    function getInvoice() {
        setIsLoading(true);
        Invoices.getOneById({
            id,
            onSuccess: (data) => {
                setInvoice(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    async function getResources() {
        const data = await Products.getAllAsync();
        setResources((prev) => ({ ...prev, products: data }));
    }

    useEffect(() => {
        if (id) {
            getInvoice();
        }
    }, [id]);

    useEffect(() => {
        getResources();
    }, []);

    function onCancelHandler() {
        history.push(`/invoicing`);
    }

    function onViewInvoiceHandler() {
        history.push(`/invoicing/${invoice.id}/report`);
    }

    function onSuccess(newInvoiceId, setSubmitting) {
        dispatch(notifySuccess("Invoice created successfully"));
        setSubmitting(false);
        if (adding) {
            setIsUserCreating(true);
        }
        history.push(`/invoicing/${newInvoiceId}/update`);
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    function onSubmitHandler(values, { setSubmitting, setErrors }) {
        if (adding) {
            const { client } = values;
            setSubmitting(true);
            Invoices.add({
                payload: {
                    id: null,
                    clientId: client.id,
                },
                onSuccess: (newInvoiceId) => onSuccess(newInvoiceId, setSubmitting),
                onError: (error) => onError(error, setSubmitting, setErrors),
            });
        }
    }

    return (
        <Page>
            <Header title="Invoice" />
            {isLoading && <LoadingPage />}
            {!isLoading && (
                <Grid container direction="column" spacing={4} className="invoicing">
                    <Grid item>
                        <MasterForm invoice={invoice} {...props} onCancel={onCancelHandler} onSubmit={onSubmitHandler} title={`# ${invoice?.consecutive}`} />
                    </Grid>
                    {updating && invoice && invoice.id && (
                        <Grid item>
                            <Grid container direction="row" justifyContent="flex-start" spacing={4}>
                                <Grid item sm={12} md={4}>
                                    <DetailForm
                                        invoiceId={invoice.id}
                                        detailData={selectedDetail}
                                        resources={resources}
                                        onCancel={() => setSelectedDetail(undefined)}
                                        onDetailSuccess={getInvoice}
                                        isUserCreating={isUserCreating}
                                        setSelectedDetail={setSelectedDetail}
                                    />
                                </Grid>
                                <Grid item sm={12} md={8}>
                                    <DetailTable
                                        data={invoice.invoiceDetails}
                                        resources={resources}
                                        onRowClick={setSelectedDetail}
                                        onRowsDeleted={getInvoice}
                                        isUserCreating={isUserCreating}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="button-group">
                                        <Button outline secondary onClick={onCancelHandler}>
                                            Cancel
                                        </Button>
                                        <Button secondary onClick={onViewInvoiceHandler}>
                                            View invoice
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}
            <ConfirmDialog {...confirmDialogProps} />
        </Page>
    );
}

Invoice.propTypes = {
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
    title: PropTypes.string,
};

export default withRouter(Invoice);
